module.exports = __webpack_public_path__ + "img/language.03fcbb01.svg";